import { styled } from "@mui/material";
import { TrustIcon } from "../../assets/icons/TrustIcon.js";
import "react/jsx-runtime";
const CareLevelIcon = styled(TrustIcon)`
  width: 16px !important;
  height: 16px !important;
  margin-left: 8px;
`;
export {
  CareLevelIcon
};
